<template>
  <div class="space-y-4">
    <h2>{{ t('extraKmPriceSteps') }}</h2>
    <p>{{ t('description') }}</p>
    <MultipleValuesListField
      name="pricePerExtraKmSteps"
      :button-text="t('addPrice')"
      :field-settings="fieldSettings"
      show-delete-alert
    />
  </div>
</template>

<script lang="ts" setup>
import MultipleValuesListField, {
  type FieldSettings,
} from '@/components/MultipleValuesListField.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: null,
    label: t('pricePerExtraKm'),
    type: 'number',
    min: 0,
    maxFractionDigits: 2,
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "extraKmPriceSteps": "extra km price steps",
    "addPrice": "+ Add price",
    "pricePerExtraKm": "Price per extra km",
    "description": "The price per extra km is calculated automatically and the resulting value is rounded up to the next higher price set here."
  },
  "de": {
    "extraKmPriceSteps": "Extra-KM Preisstufen",
    "addPrice": "+ Preis hinzufügen",
    "pricePerExtraKm": "Preis pro Extra-KM",
    "description": "Der Preis pro Extra-KM wird automatisch berechnet und der resultierende Wert dann auf den nächsthöheren, hier festgelegten, Preis aufgerundet."
  },
  "es": {
    "extraKmPriceSteps": "Tramos de precio por km extra",
    "addPrice": "+ Añadir precio",
    "pricePerExtraKm": "Precio por km extra",
    "description": "El precio por km extra se calcula automáticamente y el valor resultante se redondea al alza al siguiente precio definido aquí."
  }
}
</i18n>
